var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wpf:paid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.42788 3.00562C9.29626 3.02433 9.1752 3.08748 9.08519 3.18439L5.28096 7.00375H2.57692C2.23077 7.00375 2 7.23221 2 7.57491V8.71723C2 9.05993 2.23077 9.28839 2.57692 9.28839H2.63115L4.19923 14.6076C4.25692 14.8361 4.48769 15 4.77615 15H14.2954C14.5262 15 14.7569 14.8355 14.8723 14.607L16.4231 9.28839C16.7692 9.28839 17 9.05993 17 8.71723V7.57491C17 7.23221 16.7692 7.00375 16.4231 7.00375H13.7727L9.91538 3.16612C9.85217 3.1039 9.77526 3.05703 9.69068 3.02918C9.60609 3.00134 9.51614 2.99327 9.42788 3.00562ZM9.5 4.39811L12.1504 7.00375H6.90385L9.5 4.39811ZM12.1325 8.59215C12.2479 8.59215 12.3517 8.63156 12.4383 8.71723L12.8537 9.11019C13.0267 9.28154 13.0267 9.58083 12.8537 9.75217L9.39212 13.1791C9.21904 13.3505 8.91615 13.3505 8.7425 13.1791L6.79596 11.2338C6.62288 11.0624 6.62288 10.7808 6.79596 10.6095L7.19231 10.1983C7.36538 10.0269 7.65038 10.0269 7.82346 10.1983L9.10365 11.4662L11.8077 8.71723C11.8952 8.63501 12.0119 8.59009 12.1325 8.59215Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidIcon);
export default __webpack_public_path__ + "static/media/paid-icon.135616dd523634337f73fcee92b782d8.svg";
export { ForwardRef as ReactComponent };